import { USER_STUB } from '../stubs/user';
export const StubContext = {
    jwtToken: '',
    expiryTimeToLive: 600000,
    expiryDuration: 600000,
    activeContext: null,
    contexts: [],
    user: USER_STUB,
    activeContextId: null
};
const StubOrgContext = {
    resources: [],
    displayName: '',
    organizationId: 1,
    organizationName: '',
    organizationCode: '',
    tenantId: '',
    parentLevel: 1,
    organizationType: '',
    serviceLines: []
};
export const ReadOnlyDictionaryContext = {
    ...StubContext,
    activeContext: {
        ...StubOrgContext,
        resources: [
            {
                label: 'Dictionary',
                resourceName: 'dictionary',
                permissionLevel: 'READ_ONLY',
                resourceId: 1,
                type: '',
                parentId: 1,
                sequence: -1,
                serviceLines: [
                    '*'
                ],
                metadata: ''
            }
        ]
    }
};
export const FullAccessDictionaryContext = {
    ...ReadOnlyDictionaryContext,
    activeContext: {
        ...StubOrgContext,
        resources: [
            {
                label: 'Dictionary',
                resourceName: 'dictionary',
                permissionLevel: 'FULL_ACCESS',
                resourceId: 1,
                type: '',
                parentId: 1,
                sequence: -1,
                serviceLines: [
                    '*'
                ],
                metadata: ''
            }
        ]
    }
};
